<template>
	<div class="footer w-full mt-auto">
		<div class="container mx-auto">
			<div class="px-px py-5 flex justify-center">
				<span class="text-tiny text-surface-6 text-center">
					© {{ new Date().getFullYear() }} Castr. All rights reserved
				</span>
			</div>
		</div>
		<UploadFiles />
		<GlobalUppyUploader />
	</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex';
import SubscriptionService from '@/services/SubscriptionService'
import UploadFiles from "@/components/ui/UploadFiles.vue"
import GlobalUppyUploader from "@/components/ui/GlobalUppyUploader.vue"

export default {
	name: 'AppFooter',
	components: {
		UploadFiles,
		GlobalUppyUploader
	},
  	async mounted () {
		try {
			if (this.baseSubscription) {
				this.baseSubscription.unsubscribeProcessing = false
			}
			this.userSubscription = { subscription: this.baseSubscription, addonSubscriptions: this.addonSubscriptions};

			if (_.isArray(this.userSubscription.addonSubscriptions)) {
				this.userSubscription.addonSubscriptions.forEach((sub) => {
					if (sub.package.baseCharge > 0) {
						this.paidSub = true;
					}
				});
			}

			const baseCharge = _.get(this.userSubscription, ['subscription', 'package', 'baseCharge'], 0);
			if (baseCharge > 0) {
				this.paidSub = true;
			}
		} catch (e) {
			console.log('error', e)
		}
	},
	computed: {
		...mapGetters({
			baseSubscription: 'User/baseSubscription',
			addonSubscriptions: 'User/addonSubscriptions'
		}),
		activeTeam(){
			return this.$store.state.User.activatedTeam;
		}
	},
  	data() {
   		return {
      		userSubscription: null,
      		paidSub: false
    	}
  	}
}
</script>

<style scoped>

</style>
